export default "__VITE_ASSET__BL_OGdYu__"